/**
 * Turbo Configuration - BRONCANO
 * Configuración específica para Turbo.js
 */

// Configurar Turbo cuando esté disponible
document.addEventListener('turbo:load', function() {
    configureTurbo();
});

function configureTurbo() {
    if (typeof Turbo !== 'undefined') {
        // Configuraciones de Turbo
        Turbo.session.drive = true;
        
        // Configurar cache
        Turbo.setProgressBarDelay(300);
        
        // Enlaces que deben abrir en nueva ventana
        document.addEventListener('turbo:click', function(event) {
            const link = event.target.closest('a');
            if (link) {
                const href = link.getAttribute('href');
                
                // Abrir enlaces externos en nueva ventana
                if (href && (href.startsWith('http') || href.startsWith('mailto:'))) {
                    event.preventDefault();
                    window.open(href, '_blank', 'noopener,noreferrer');
                }
            }
        });

        // Eventos personalizados
        document.addEventListener('turbo:before-cache', function() {
            // Limpiar antes de guardar en cache
            document.body.classList.remove('turbo-loading');
        });

        document.addEventListener('turbo:visit', function() {
            // Mostrar indicador de carga
            document.body.classList.add('turbo-loading');
        });

        document.addEventListener('turbo:load', function() {
            // Quitar indicador de carga
            document.body.classList.remove('turbo-loading');
            
            // Reinicializar componentes
            reinitializeComponents();
        });

    } else {
        console.log('Turbo.js no encontrado, navegación estándar activada');
    }
}

function reinitializeComponents() {
    // Reinicializar Intersection Observer
    if (typeof setupIntersectionObservers === 'function') {
        setupIntersectionObservers();
    }

    // Reinicializar iconos de Iconify
    if (typeof Iconify !== 'undefined') {
        Iconify.scan();
    }

    // Reinicializar videos
    const videos = document.querySelectorAll('video[autoplay]');
    videos.forEach(video => {
        video.play().catch(e => console.log('Video autoplay prevented:', e));
    });
}

// CSS para indicador de carga Turbo
const turboStyles = `
    .turbo-loading {
        cursor: wait;
    }
    
    .turbo-loading * {
        pointer-events: none;
    }
    
    .turbo-progress-bar {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2000;
        height: 3px;
        background: var(--color-orange-500, #FF6600);
        transform: translateX(-100%);
        transition: transform 300ms ease;
    }
    
    .turbo-progress-bar.turbo-progress-bar--visible {
        transform: translateX(0%);
    }
`;

// Inyectar estilos
const turboStyleSheet = document.createElement('style');
turboStyleSheet.textContent = turboStyles;
document.head.appendChild(turboStyleSheet);